import { AxiosInstance } from "axios";
import { createApiClient } from "./apiClient";
import { ApiClientConfig } from "./types";

class ServiceRegistry {
  private static instance: ServiceRegistry;
  private adminClient?: AxiosInstance;
  private adminConfig?: ApiClientConfig;

  private constructor() {}

  static getInstance(): ServiceRegistry {
    if (!ServiceRegistry.instance) {
      ServiceRegistry.instance = new ServiceRegistry();
    }
    return ServiceRegistry.instance;
  }

  initializeAdmin(config: ApiClientConfig): void {
    this.adminConfig = config;
    this.adminClient = createApiClient(config);
  }

  getAdminClient(): AxiosInstance {
    if (!this.adminClient) {
      throw new Error(
        "Admin client not initialized. Call initializeAdmin() first.",
      );
    }
    return this.adminClient;
  }

  isAdminInitialized(): boolean {
    return !!this.adminClient;
  }

  getAdminConfig(): ApiClientConfig | undefined {
    return this.adminConfig;
  }

  resetAdmin(): void {
    this.adminClient = undefined;
    this.adminConfig = undefined;
  }
}

export const serviceRegistry = ServiceRegistry.getInstance();
